<template>
  <div class="list-group-item list-group-item-with-icon card-transaction"
       :id="`transaction-${transaction.transactionId}`">
    <div>
      <strong class="transaction-description">{{ transaction.description }}</strong>
      <div class="small text-muted transaction-date">{{ formattedDate(transaction.date) }}</div>
    </div>
    <TransactionAmount :amount="transaction.amount" :currency="transaction.currency"/>
  </div>
</template>

<script>

import TransactionAmount from '@shared/components/wallet/TransactionAmount'
import TransactionDateMixin from '@shared/mixins/TransactionDateMixin'

export default {
  props: ['transaction'],
  components: {
    TransactionAmount
  },
  mixins: [TransactionDateMixin]
}
</script>
